/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2016, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
export function stopEvent(e) {
	// eslint-disable-line import/prefer-default-export
	e.preventDefault();
	e.stopPropagation();
}
